import { render } from "./PhrasesView.vue?vue&type=template&id=1e93a7cf"
import script from "./PhrasesView.vue?vue&type=script&lang=js"
export * from "./PhrasesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__